import { render, staticRenderFns } from "./tc-help.vue?vue&type=template&id=e5333c4a&"
import script from "./tc-help.vue?vue&type=script&lang=js&"
export * from "./tc-help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports